var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 8C35.9411 8 44 16.0589 44 26C44 34.6693 30.3147 54.072 26.8107 58.8987C26.6213 59.1569 26.3202 59.3094 26 59.3094C25.6798 59.3094 25.3787 59.1569 25.1893 58.8987C21.6853 54.072 8 34.6693 8 26C8 16.0589 16.0589 8 26 8Z",
    fill: "#F2FCEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 2C41.9411 2 50 10.0589 50 20C50 28.6693 36.3147 48.072 32.8107 52.8987C32.6213 53.1569 32.3202 53.3094 32 53.3094C31.6798 53.3094 31.3787 53.1569 31.1893 52.8987C27.6853 48.072 14 28.6693 14 20C14 10.0589 22.0589 2 32 2Z",
    fill: "white",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 28C36.4183 28 40 24.4183 40 20C40 15.5817 36.4183 12 32 12C27.5817 12 24 15.5817 24 20C24 24.4183 27.5817 28 32 28Z",
    fill: "#F2FCEE",
    stroke: "#228800",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.944 47.4238C55.2293 48.8665 60 51.2745 60 53.9998C60 58.4185 47.4667 61.9998 32 61.9998C16.5333 61.9998 4 58.4185 4 53.9998C4 51.2798 8.74933 48.8772 16 47.4318",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "assets/media/mapPin.b565d09ad17cb69fb91db038a4176c94.svg";
export { ForwardRef as ReactComponent };